/**
 * Performs a nested key lookup on an object and returns its value.
 *
 * @param {Object} obj Object to lookup
 * @param {String} key Nested key (format: "a.b.c")
 *
 * @return Value of the nested key
 */
function getNestedObjectLookup(obj = {}, key = "") {
    return String(key)
        .split(".")
        .reduce((a, k) => a && a[k], obj);
}

export default getNestedObjectLookup;
